import forEach from 'lodash/forEach';
import isObject from 'lodash/isObject';
/* 
                                              
  
                                                                             
                                                                          
                                                                             
                                                           
  
                                                                              
                                                                        
  
                                                                           
                                                                             
  
           
                                                                     
                                   
 */
export function getPath(model) {
    const path = model.path || [];
    const { segment, segmentId, route, routeId } = model;
    if (path[0] === undefined && segment !== undefined)
        path[0] = segment;
    if (path[1] === undefined && segmentId !== undefined)
        path[1] = segmentId;
    if (path[2] === undefined && route !== undefined)
        path[2] = route;
    if (path[3] === undefined && routeId !== undefined)
        path[3] = routeId;
    return path;
}
/* 
                                                     
  
                                                                          
                                                                         
                                                                             
                                         
  
                                     
                                                                    
  
           
                               
                                    
                        
 */
export function hasPath(model) {
    const { path, segment, segmentId, route, routeId } = model;
    return Boolean(Array.isArray(path) || segment || segmentId || route || routeId);
}
/* 
                                                                   
  
                                                            
                                                                          
                                                                               
                                                                         
  
                                                                      
                                                                     
                                                                           
                                                            
  
                                                                       
                                                                                 
  
           
                                                       
                                                                                 
 */
export function parseBIURLFragment(fragment) {
    let pathStr = fragment;
    let search = '';
    if (fragment.match(/^#+(.*?)(?:\?(.*))?$/)) {
        pathStr = RegExp.$1;
        search = RegExp.$2 || '';
    }
    else if (fragment !== '') {
        console.assert(false, 'Invalid URL Fragment', fragment);
    }
    const path = pathStr
        .split('/')
        .map(v => decodeURIComponent(v))
        .map(v => (v === '' ? null : v.match(/^\d+$/) ? +v : v));
    if (path[0] === null)
        path.splice(0, 1);
    const segment = path[0] ?? null;
    const segmentId = path[1] ?? null;
    const route = path[2] ?? null;
    const routeId = path[3] ?? null;
    return { path, segment, segmentId, route, routeId, search };
}
/* 
                                                     
  
                                                                     
                                                                              
                                                                             
                                             
  
                                            
                                                                                
  
           
                                                            
                        
 */
export function serializeUrlMainPart(hash) {
    const path = hash.path;
    if (!path.length)
        return '';
    return '#/' + path.map(p => (p === null || p === undefined ? '' : String(p))).join('/');
}
/* 
                                                                           
                            
  
                                                                            
                                                                           
                                                                
  
                                     
                                                                             
  
           
                                         
                       
 */
export function isHash(value) {
    return isObject(value) && !Array.isArray(value) && typeof value !== 'function';
}
/* 
                                                                      
  
                                                                            
                                                                        
                                                                         
                                                                              
                                                     
  
                                                           
                                                     
                                                                 
                                                           
  
           
                                                                                           
                                  
 */
export function extendHash(current, additional, structure) {
    if (additional === undefined)
        return current;
    if (!isHash(additional))
        return additional;
    if (!isHash(current))
        return additional;
    const result = {};
    forEach(structure, (type, key) => {
        const value = _extendWithStructure(current[key], additional[key], type);
        if (value !== undefined)
            result[key] = value;
    });
    return result;
}
/* 
                                                                       
  
                                                                          
                                                                         
                                                                          
                                                                    
  
                                        
                                         
                                                            
                                                                                
  
           
                                                           
                                                     
 */
export function _extendWithStructure(current, additional, structure) {
    if (isHash(structure))
        return extendHash(current, additional, structure);
    return additional !== undefined ? additional : current;
}
/* 
                                                                          
  
                                                              
                                                                            
                                                                          
                                                                          
                                                          
  
                                        
                                                                  
                                                         
                                                                                   
  
           
                                                                          
                                
 */
export function extend(current, additional, structure) {
    const result = _extendWithStructure(current, additional, structure);
    //                                                
    for (const key of Object.keys(current ?? {})) {
        if (!(key in structure))
            result[key] = current[key];
    }
    for (const key of Object.keys(additional ?? {})) {
        if (!(key in structure))
            result[key] = additional[key];
    }
    return result;
}
